export const streetParkingInfoSelector = ({streetParkingInfo}) => streetParkingInfo